var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { ThemeProvider } from 'styled-components';
import Control from './Control';
import Label from './Label';
import Break from './Break';
import theme from './theme';
var PaginationWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
export var Pagination = function (_a) {
    var _b = _a.activePage, activePage = _b === void 0 ? 1 : _b, buildUrl = _a.buildUrl, className = _a.className, _c = _a.hasPrevNextText, hasPrevNextText = _c === void 0 ? true : _c, _d = _a.hasPrevNext, hasPrevNext = _d === void 0 ? true : _d, _e = _a.maxTotalPages, maxTotalPages = _e === void 0 ? 7 : _e, _f = _a.maxAdjacentPages, maxAdjacentPages = _f === void 0 ? 1 : _f, pages = _a.pages, onChange = _a.onChange;
    var _g = useState(activePage), currentPage = _g[0], setCurrentPage = _g[1];
    var pagesArray = Array.from(new Array(pages), function (_, i) { return i + 1; });
    /* set currentPage if activePage prop changes */
    useEffect(function () {
        setCurrentPage(activePage);
    }, [activePage]);
    var handleChange = function (page) {
        var newPage = page === 0 ? 1 : page === pages + 1 ? pages : page;
        setCurrentPage(newPage);
        if (onChange) {
            onChange(newPage);
        }
    };
    var getControlElement = function (page) { return (React.createElement(Control, { active: currentPage === page, key: page, onClick: function () { return handleChange(page); }, 
        // eslint-disable-next-line no-undefined
        to: buildUrl ? buildUrl(page) : undefined, value: page })); };
    var paginationItems = function () {
        if (pages <= maxTotalPages) {
            return pagesArray.map(getControlElement);
        }
        var centerPageRange = maxTotalPages - maxAdjacentPages * 2 - 2;
        var activePageLowerEnd = currentPage - Math.floor(centerPageRange / 2);
        var activePageUpperEnd = currentPage + Math.floor(centerPageRange / 2);
        return pagesArray.map(function (page) {
            // Add margin pages
            if (page <= maxAdjacentPages || page > pagesArray.length - maxAdjacentPages) {
                return getControlElement(page);
            }
            // Add the first few pages if the active page is in range
            if (page <= centerPageRange + maxAdjacentPages + 1 &&
                activePageLowerEnd <= maxAdjacentPages + 2) {
                return getControlElement(page);
            }
            // Add the last few pages if the active page is in range
            if (page >= pagesArray.length - centerPageRange - maxAdjacentPages &&
                activePageUpperEnd > pagesArray.length - maxAdjacentPages - 2) {
                return getControlElement(page);
            }
            // Add center page, if it is in range of the active page
            if ((page - activePageLowerEnd) * (page - activePageUpperEnd) <= 0) {
                return getControlElement(page);
            }
            // Add break after maxAdjacentPages pages
            if (page === maxAdjacentPages + 1 || page === pagesArray.length - maxAdjacentPages) {
                return React.createElement(Break, { key: page });
            }
            return null;
        });
    };
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(PaginationWrapper, { className: className },
            hasPrevNext && (React.createElement(Label, { onClick: function () { return handleChange(currentPage - 1); }, previous: true, visible: currentPage !== 1 }, hasPrevNextText && (React.createElement(FormattedMessage, { defaultMessage: "Previous", id: "pagination.previous" })))),
            paginationItems(),
            hasPrevNext && (React.createElement(Label, { next: true, onClick: function () { return handleChange(currentPage + 1); }, visible: currentPage !== pages }, hasPrevNextText && React.createElement(FormattedMessage, { defaultMessage: "Next", id: "pagination.next" }))))));
};
export default Pagination;
var templateObject_1;
//# sourceMappingURL=index.js.map